import { migrateLegacyColumnWidths } from '@/utils/warehouseTableHelpers'

export const WAREHOUSE_VENDORS_PAGE_KEY = 'warehouse-vendors'

export const WAREHOUSE_VENDORS_COLUMN_KEYS = ['id', 'name', 'qbo_vendor_id', 'actions'] as const

export const WAREHOUSE_VENDORS_DEFAULT_WIDTHS: Record<string, number> = {
  id: 96,
  name: 220,
  qbo_vendor_id: 160,
  actions: 76,
}

export const LEGACY_WIDTH_KEYS = ['bookkeeper:warehouse-vendors-table-widths'] as const

export function migrateWarehouseVendorsColumnWidths(): void {
  migrateLegacyColumnWidths(
    WAREHOUSE_VENDORS_PAGE_KEY,
    LEGACY_WIDTH_KEYS,
    WAREHOUSE_VENDORS_COLUMN_KEYS
  )
}
